import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CaseSearchResultsLite } from 'src/app/shared/models/cases/caseSearchResults';
import { ClientLiteSearchResults } from 'src/app/shared/models/clients/clientSearchResults';
import { DashboardData } from 'src/app/shared/models/dashboardData';
import { CaseSessionSearchResults } from 'src/app/shared/models/hearings/hearingSearchResults';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { TimesheetEntrySearchResults } from 'src/app/shared/models/timesheet/timesheetSearchResults';
import { environment } from 'src/environments/environment';
import { ErrorService } from '../error/error.service';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardApiService extends ApiBaseService {

  baseUrl = environment.backend_host + '/api/dashboard';

  constructor(
    public http: HttpClient,
    protected errorService: ErrorService,
    protected spinner: NgxSpinnerService) {
    super(spinner, errorService);
  }

  public getDashboardData = (): Observable<DashboardData> => {
    return this.http.get(`${this.baseUrl}/`).pipe(map(this.deserializeAs(DashboardData)));
  }

  public getAdminDashboardNotificationCount = (): Observable<any> => {
    return this.http.get(`${this.baseUrl}/admin-counts`);
  }

  public getDataEntryDashboardNotificationCount = (): Observable<any> => {
    return this.http.get(`${this.baseUrl}/data-entry-counts`);
  }

  public getNewCases = (params: SearchParams): Observable<CaseSearchResultsLite> => {
    const p = this.serializeParamsObj(params, new HttpParams());
    return this.http.get(`${this.baseUrl}/new-cases`, { params: p })
      .pipe(map(this.deserializeAs(CaseSearchResultsLite)));
  }

  public getPendingCases = (params: SearchParams): Observable<CaseSearchResultsLite> => {
    const p = this.serializeParamsObj(params, new HttpParams());
    return this.http.get(`${this.baseUrl}/pending-cases`, { params: p })
      .pipe(map(this.deserializeAs(CaseSearchResultsLite)));
  }

  public getNewClients = (params: SearchParams): Observable<ClientLiteSearchResults> => {
    const p = this.serializeParamsObj(params, new HttpParams());
    return this.http.get(`${this.baseUrl}/new-clients`, { params: p })
      .pipe(map(this.deserializeAs(ClientLiteSearchResults)));
  }

  public getOverdueHearings = (params: SearchParams): Observable<CaseSessionSearchResults> => {
    const p = this.serializeParamsObj(params, new HttpParams());
    return this.http.get(`${this.baseUrl}/overdue-hearings`, { params: p })
      .pipe(map(this.deserializeAs(CaseSessionSearchResults)));
  }

  public getOverdueTimesheets = (params: SearchParams): Observable<TimesheetEntrySearchResults> => {
    const p = this.serializeParamsObj(params, new HttpParams());
    return this.http.get(`${this.baseUrl}/overdue-timesheet`, { params: p })
      .pipe(map(this.deserializeAs(TimesheetEntrySearchResults)));
  }

  public getRejectedCases = (params: SearchParams): Observable<CaseSearchResultsLite> => {
    const p = this.serializeParamsObj(params, new HttpParams());
    return this.http.get(`${this.baseUrl}/rejected-cases`, { params: p })
      .pipe(map(this.deserializeAs(CaseSearchResultsLite)));
  }


}